export const EMPTY_SOURCE = {
  promotion_source: undefined,
  platform: [],
  job_boards: [],
  promotion_period_type: undefined,
  duration: undefined,
};

export const INITIAL_VALUES = {
  sources: [{ ...EMPTY_SOURCE }],
  openings: [{ opening: undefined }],
  prior_opening: undefined,
  request_title: '',
  description: '',
  description_initial: '',
  search_regions: [],
  technology_areas: [],
  translation_languages: [],
  additional_requirements: '',
  additional_requirements_initial: '',
  recruiter_leads: [],
  team_lead_notification_recipients: [],
};
